<mat-accordion class="expandable" [class.expandable--themeless]="themeless" [class.expandable--block]="!inline" hideToggle>
  <div
    class="expandable__header cursor-pointer"
    role="button"
    [id]="expansionPanel._headerId"
    [attr.tabindex]="disabled ? -1 : 0"
    [attr.aria-expanded]="expanded"
    [attr.aria-disabled]="disabled"
    [attr.aria-controls]="expansionPanel.id"
    (click)="toggle()"
    (keydown.enter)="$event.preventDefault(); toggle()"
    (keydown.space)="$event.preventDefault(); toggle()"
  >
    <app-row gutter="x-xs" align="center" [wrap]="inline">
      <app-col [cols]="inline ? 'auto' : null">
        <ng-content select="[toggle]"></ng-content>
      </app-col>
      <app-col cols="auto">
        <!-- A custom toggleIcon rotates in place; the default material chevron swaps glyph instead. -->
        <app-icon
          [name]="toggleIcon || (expanded ? 'arrow-outline-up' : 'arrow-outline-down')"
          aria-hidden="true"
          size="xs"
          class="expandable__toggle-icon d-inline-flex align-middle text-500"
          [class.expandable__toggle-icon--expanded]="toggleIcon && expanded"
        ></app-icon>
      </app-col>
    </app-row>
  </div>
  <mat-expansion-panel
    class="expandable__panel"
    [class.mat-elevation-z0]="themeless"
    #expansionPanel
    [disabled]="disabled"
    [expanded]="expanded"
    (opened)="expanded = true; opened.emit();"
    (closed)="expanded = false; closed.emit();"
  >
    <ng-content></ng-content>
  </mat-expansion-panel>
</mat-accordion>
